// RT tells the candidate portal the job's type: T for Temporary and Contract jobs, P for Permanent jobs
const getJobRoleType = (jobType = []) => {
  const types = [].concat(jobType);
  const hasType = (pattern) => types.some((type) => pattern.test(type || ""));

  if (hasType(/\b(temporary|contract)\b/i)) return "T";
  if (hasType(/\bpermanent\b/i)) return "P";
  return null;
};

export const getJobApplyUrl = ({ job, branchId, jobType }) => {
  let url = `https://candidates.gap-personnel.com/#/welcome?fxbranch=${branchId}&job_id=${parseInt(job.id.split("-")[0], 16)}&job_ref=${job.external_reference}&job_title=${job.title}`;

  const roleType = getJobRoleType(jobType);
  if (roleType) {
    url += `&RT=${roleType}`;
  }

  return url;
};
